export default __webpack_public_path__ + "static/media/plaid.243fc828793e4b6c02abd9af67ad2363.svg";